import axiosClient from './axiosClient';
import { IBaseResponse } from '~/utils/interface/base';

export interface IInstalledApp {
  packageName: string;
  displayName: string;
  iconUrl?: string | null;
  isAllowed: boolean;
}

const kioskApi = {
  // what the senior's device reported as installed, each with whether it is allowed in Protect Mode
  getAllowedApps() {
    return axiosClient.get<IBaseResponse<{ apps: IInstalledApp[] }>>('kiosk/allowed-apps');
  },
  updateAllowedApps(allowedApps: string[]) {
    return axiosClient.put<IBaseResponse<unknown>>('kiosk/allowed-apps', { allowedApps });
  },
};

export default kioskApi;
